import { List, ListItem , Box } from "@mui/material";
import { GlobalContext } from "../../globalState";
import { useContext } from "react";

const ShiftCountGroupMstEditList = (props) => {
    const { list, includeLsit ,height, keyName, name1, name2, sortKey, selectedKey, handleOnClick, handleOnDoubleClick } = props;

    const shiftGroupInfo = useContext(GlobalContext).shiftGroupInfo;

    const styles = {
        list:{
            height:height,
            overflow: 'auto',
            margin:"10px",
            border: '1px solid gray'
        },
        item_column:{
            width: '50%'
        },
        key_column:{
            width: '20%'
        },
        name_column:{
            width: '40%'
        },
        selected_item:{
            backgroundColor: '#F0F0F0',
            borderLeft: '2px solid green'
        },
        del_item:{
            backgroundColor: 'lightgray',
            borderLeft: '2px solid red'
        },
        include_item:{
            backgroundColor: '#BDE3C3',
            borderLeft: '2px solid green'
        }
    }
    return (
        <List sx={styles.list}>
            {list.map((item) => (
                <ListItem key={item._id} 
                  onClick={handleOnClick?()=>handleOnClick(item):null} 
                  onDoubleClick={handleOnDoubleClick?()=>handleOnDoubleClick(item):null}
                  sx={selectedKey === item[keyName] ? styles.selected_item 
                    : item.log_del_flg ? styles.del_item 
                    : includeLsit.includes(item[keyName]) ? styles.include_item : {}}>
                    <Box sx={{...styles.item_column, ...styles.key_column}}>{item[keyName]}</Box>
                    <Box sx={{...styles.item_column, ...styles.name_column}}>{item[name1]}</Box>
                    <Box sx={{...styles.item_column, ...styles.name_column}}>{shiftGroupInfo[item[name2]] ? shiftGroupInfo[item[name2]].name : item[name2]}</Box>
                </ListItem>
            ))}
        </List>
    )
}

export default ShiftCountGroupMstEditList;  